import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="mx-auto flex max-w-[1200px] flex-col items-center px-4 pb-20 pt-32 text-center md:px-8 md:pt-40">
      <span className="flex h-20 w-20 items-center justify-center rounded-full bg-background-200 font-heading text-3xl font-bold text-foreground-500">
        404
      </span>
      <h1 className="mt-6 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
        页面走丢了
      </h1>
      <p className="mt-3 max-w-md text-sm text-foreground-600">
        你访问的页面不存在或已被移动，不如回到首页，继续寻找属于你的黑丝搭配灵感。
      </p>
      <div className="mt-8 flex flex-wrap justify-center gap-4">
        <Link
          to="/"
          className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-foreground-950 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-home-4-line" /> 返回首页
        </Link>
        <Link
          to="/categories"
          className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-foreground-200 px-6 py-3 text-sm font-semibold text-foreground-800 transition-colors hover:border-foreground-300"
        >
          浏览分类
        </Link>
      </div>
    </div>
  );
}